/**
 *
 * @param file Dom File object
 */
export function getFileMimeType(file) {
  var _file$name, _file$name$toLowerCas, _file$name$toLowerCas2, _file$name$toLowerCas3;
  if (!file) return '';
  return (file === null || file === void 0 ? void 0 : file.type) || (file !== null && file !== void 0 && (_file$name = file.name) !== null && _file$name !== void 0 && (_file$name$toLowerCas = _file$name.toLowerCase) !== null && _file$name$toLowerCas !== void 0 && (_file$name$toLowerCas2 = _file$name$toLowerCas.call(_file$name)) !== null && _file$name$toLowerCas2 !== void 0 && (_file$name$toLowerCas3 = _file$name$toLowerCas2.includes) !== null && _file$name$toLowerCas3 !== void 0 && _file$name$toLowerCas3.call(_file$name$toLowerCas2, 'heic') ? 'image/heic' : '');
}